var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderFavourite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:folder-favourite"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83317 5.41659H13.9582C15.714 5.41659 16.5915 5.41659 17.2223 5.83825C17.495 6.02054 17.7292 6.25471 17.9115 6.52742C18.2615 7.05242 18.3215 7.89075 18.3315 9.16659M9.99984 5.41659L9.47234 4.36075C9.03484 3.48575 8.63484 2.60575 7.66567 2.24242C7.2415 2.08325 6.7565 2.08325 5.7865 2.08325C4.27317 2.08325 3.5165 2.08325 2.94817 2.39992C2.54323 2.62586 2.20912 2.95998 1.98317 3.36492C1.6665 3.93325 1.6665 4.68992 1.6665 6.20325V8.74992C1.6665 12.6783 1.6665 14.6424 2.8865 15.8624C3.96984 16.9458 5.63984 17.0683 8.74984 17.0816M11.7848 11.6183C12.7907 11.0083 13.6682 11.2541 14.1957 11.6449C14.4115 11.8058 14.5198 11.8858 14.5832 11.8858C14.6465 11.8858 14.7548 11.8058 14.9707 11.6449C15.4982 11.2541 16.3757 11.0083 17.3815 11.6183C18.7015 12.4174 18.9998 15.0549 15.9565 17.2808C15.3757 17.7041 15.0865 17.9166 14.5832 17.9166C14.0798 17.9166 13.7907 17.7041 13.2107 17.2808C10.1665 15.0558 10.4648 12.4174 11.7848 11.6183Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFavourite);
export default __webpack_public_path__ + "static/media/folder-favourite.e139da33482ac296df565df21299defd.svg";
export { ForwardRef as ReactComponent };